import type { CardStylesConfig } from "./branding.types";
import type { UserEntity } from "./identities-api.types";
import type { Identity } from "./identities-api.types";

export const OrganizationStatus = {
  ACTIVE: "active",
  INACTIVE: "inactive",
  SUSPENDED: "suspended",
  PENDING: "pending",
} as const;

export type OrganizationStatus = (typeof OrganizationStatus)[keyof typeof OrganizationStatus];

export const Provider = {
  BLOQUE: "BLOQUE",
  CRYPTO_MATE: "CRYPTO_MATE",
} as const;

export type Provider = (typeof Provider)[keyof typeof Provider];

export type { CardStylesConfig } from "./branding.types";

export interface Organization {
  id: string;
  name: string;
  slug: string | null;
  email: string;
  phone: string | null;
  status: OrganizationStatus;
  created_by_user_id: string;
  created_by: UserEntity | null;
  users: UserEntity[] | null;
  card_provider: Provider | null;
  webhook_urls: string[] | null;
  webhook_secret: string | null;
  card_styles_config: CardStylesConfig | null;
  can_customize_card_design: boolean;
  payout_batches_enabled?: boolean;
  organization_identity_id: string | null;
  organization_identity: Identity | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
}

export interface OrganizationsListResponse {
  data: Organization[];
  total: number;
  skip: number;
  limit: number;
  hasMore: boolean;
}

export interface OrganizationsApiResponse {
  data: Organization[];
  total?: number;
  skip?: number;
  limit?: number;
  hasMore?: boolean;
  current_page?: number;
  per_page?: number;
  last_page?: number;
  from?: number;
  to?: number;
}

export interface OrganizationsFilters {
  page?: number;
  per_page?: number;
  limit?: number;
  skip?: number;
  search?: string;
  status?: OrganizationStatus;
  card_provider?: Provider;
}

export interface OrganizationTableRow {
  id: string;
  name: string;
  email: string;
  phone: string | null;
  status: OrganizationStatus;
  card_provider: Provider | null;
  created_at: string;
  updated_at: string;
}
